import { useEffect, useRef } from 'react'
import { usePersonalizationWidgetData } from '@vp/design-personalization-widget'
import { useIdentity } from '@vp/ubik-context'
import { dpcsLoadingUpdate } from '~/app/store/designPersonalization/actions'
import { useDispatch } from 'react-redux'
import { contentUpdate } from '~/app/store/content'
import { ThunkDispatch } from '~/app/store/interface'
import { designPersonalizationContextIdUpdate, designPersonalizationWidgetHasImageUpdate } from '~/app/store/designPersonalization/actions'

export const ReduxBridge = (): null => {
  const reduxDispatch = useDispatch<ThunkDispatch>()
  const { auth } = useIdentity()
  const { designPersonalizationContextId, designPersonalizationHasImage, isPersonalizationWidgetUpdating } = usePersonalizationWidgetData()

  const prevHasImages = useRef<boolean>(designPersonalizationHasImage)
  const prevDpcId = useRef<string | undefined>(designPersonalizationContextId)

  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null

    if (isPersonalizationWidgetUpdating) {
      reduxDispatch(dpcsLoadingUpdate(true))
    } else {
      timeout = setTimeout(() => {
        reduxDispatch(dpcsLoadingUpdate(false))
      }, 50)
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPersonalizationWidgetUpdating])

  useEffect(() => {
    reduxDispatch(designPersonalizationContextIdUpdate(designPersonalizationContextId))
    reduxDispatch(designPersonalizationWidgetHasImageUpdate(designPersonalizationHasImage))

    // Re-fetch from DC whenever the DPC ID changes (any change, including UUID→UUID),
    // so that DC returns the correct personalized preview URLs for the new context.
    if (prevDpcId.current !== designPersonalizationContextId) {
      reduxDispatch(contentUpdate({ shouldUpdateUrl: false }))
      prevDpcId.current = designPersonalizationContextId
    }

    // Also re-fetch when hasImage status changes, for personalization boosting re-rank.
    if (prevHasImages.current !== designPersonalizationHasImage) {
      reduxDispatch(contentUpdate({ shouldUpdateUrl: false }))
      prevHasImages.current = designPersonalizationHasImage
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth, designPersonalizationContextId, designPersonalizationHasImage])

  return null
}
